//import logo from './logo.svg';
import './App.css';
import routes from './routes';
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.css';
//import 'bootstrap/dist/css/bootstrap.min.css';

import Login from './Login';
import SignUp  from './signup';
import BaseLayout from '../components/BaseLayout';
import Header from '../components/Header';
import JobDetails from './jobs/jobdetails';
import PostJobs from './jobs/jobpost';
import UpdateCompanyDetails from './company/updatecompanydetails';
import JobBoard from './jobs/jobboard';
import Footer from '../components/Footer';

import { AuthProvider } from '../auth/AuthContext';
import PrivateRoute from '../helpers/privateroute';
import AllCompaines from './adminpanel/allCompaines';

import AddCompany from './company/addCompany';
import JobListByCompany from './jobs/joblist';
import AllVeterans from './adminpanel/allveterans';
import ForgotPassword from './passwordreset/forgotpassword';
import ResetPassword from './passwordreset/resetpassword';

function App() {
  return (
    <div className="App">
              
          <Router>   
          <AuthProvider>     
            <BaseLayout header={<Header/>} footer={<Footer/>}>  
                <Switch>
                <Redirect from={routes.ROOT} to={routes.LOGIN_PAGE} exact />
                  <Route path={routes.LOGIN_PAGE}>
                    <Login />
                  </Route>
                  <Route path={routes.FORGOTPASSWORD} component={ForgotPassword} />
                  <Route path={routes.RESETPASSWORD} component={ResetPassword} />
                  <PrivateRoute path={routes.SIGNUP_PAGE} component={SignUp} />
                  <PrivateRoute path={routes.JOBDETAILS} component={JobDetails} />
                  {/* <PrivateRoute path={routes.JOBPOST} component={PostJobs} /> */}
                  <PrivateRoute path={routes.COMPANYUPDATE} component={UpdateCompanyDetails} />
                  <PrivateRoute path={routes.JOBS} component={JobBoard} />
                  <PrivateRoute path={routes.ADMINCOMPANIES} component={AllCompaines} />
                  <PrivateRoute path={routes.ADMINUPDATECOMPANY} component={UpdateCompanyDetails} />
                  <PrivateRoute path={routes.ADDCOMPANY} component={AddCompany} />
                  <PrivateRoute path={routes.ADMINVETERANS} component={AllVeterans} />               
                  <PrivateRoute path={routes.COMPANYJOBS} component={JobListByCompany} />
                </Switch>
                </BaseLayout>
                </AuthProvider>
          </Router>        
      
    </div>
  );
}

export default App;
